import doRequest from '../ApiBase';

const GetEstimateBenefits = (payload) => doRequest({
  url: '/api/illustration/process',
  method: 'POST',
  data: { ...payload },
});

export default GetEstimateBenefits;
